const alphanumericString = "1234567890qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM".split("")

const Unit = {
    second:{
        small: "s",
        normal: "second"
    },
    minute: {
        small: "m",
        normal: "minute"
    },
    hour: {
        small: "h",
        normal: "hour"
    },
    day: {
        small: "d",
        normal: "day"
    }
}

const getUnit = (value, unit, unitType = "small") => {

    const realUnit = Unit[unit.toLowerCase()][unitType]
    if(value > 1 && unitType !== "small") {
        return `${realUnit}s`
    } else {
        return `${realUnit}`
    }
}

export const formatTimestampToUnitValue = (ts, smallUnit) => {
    const SECONDS = 1000
    const MINUTE = SECONDS * 60
    const HOUR = MINUTE * 60
    const DAY = HOUR * 24
    let value = 0
    let unit = "second"
    if(ts / DAY > 1) {
        value = ts / DAY
        unit = "day"
    } else
    if(ts / HOUR > 1) {
        value = ts / HOUR
        unit = "hour"
    } else
    if(ts / MINUTE > 1) {
        value = ts / MINUTE
        unit = "minute"
    } 
    else
    {
        value = ts / SECONDS
        unit = "second"
    }
    let unitType = "normal"
    if(smallUnit) {
        unitType = "small"
    }
    const realValue = Math.floor(value)
    const realUnit = getUnit(realValue, unit, unitType)
    return [
        realValue, realUnit
    ]
}

export const createRandomString = (length) => {
    let str = ""
    let unvSize = alphanumericString.length
    while(length > 0){
      str = str + alphanumericString[Math.floor(Math.random() * unvSize)]
      length = length -1
    }
    return str;
}


// WEBPACK FOOTER //
// ./src/module-analytics/util.js